module.exports = __webpack_public_path__ + "static/media/edit-icon.75ce0d0a.svg";